import {
  Component,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { DashboardService } from 'src/app/services/dashboard.service';
import { first } from 'rxjs';
import { team } from 'src/app/core/translations/team';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-team',
  templateUrl: './team.component.html',
  styleUrls: ['./team.component.scss'],
})
export class TeamComponent {

  isHandsetPortrait: boolean = false;
  bannerImage: any ='';
  bannerClass: any ='';

  currentLanguage: string = '';
  languageTranslations: any = team;
  activeLanguageTranslations: any = {};
  teamDetails: any = null;
  
  constructor(
      private route: ActivatedRoute,
      private dashboardService: DashboardService,
    ) {

    }


  ngOnInit(): void {

    this.bannerClass = environment.pageClass;
    this.bannerImage = environment.staticPageBanner;

    this.fetchTeam();

    if (this.route.snapshot.paramMap.get('language')) {
      let language: string | null =
        this.route.snapshot.paramMap.get('language');

      if (language) {
        this.activeLanguageTranslations = this.languageTranslations[language];
      }
    }


  }

  fetchTeam() {
    this.dashboardService
      .fetchTeam()
      .pipe(first())
      .subscribe({
        next: (res: any) => {
          this.teamDetails = res?.value?.length ? res.value : null;
          // console.log(this.teamDetails);
        },
        error: () => {
          // console.log('error in fetching team');
        },
      });
  }


  isHandsetPortraitStatus(status: boolean): void {
    this.isHandsetPortrait = status;
  }

  getFirstCharofStr(str1:any, str2:any){

    let letter1 = str1.charAt(0);
    let letter2 = str2.charAt(0);

    let letter3 = letter1+letter2;

    return letter3;

  }

}
